import axios from 'axios';
import { API_BASE_URL } from '@/lib/apiBase';

const artistApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export default artistApi;
